import { h, Host } from "@stencil/core";
export class ErrorControl {
    render() {
        return (h(Host, { key: '4c9ce240408b4e54fc6692c083505ef000b28d30' }, h("slot", { key: 'c7c12c0374acf50a0d68633eb63ed81e0f34107d' })));
    }
    static get is() { return "ux-error-control"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["error-control.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["error-control.css"]
        };
    }
}
//# sourceMappingURL=error-control.js.map
